import requireAll from "services/requireAll";

let routes = {};

requireAll(require.context("./../routes", true, /\/routes\.js$/)).map(
  (module) => {
    const _data = module.data.default;
    let _routes = routes;

    let _keys = module.path.replace(/(^\.\/|\/routes\.js$)/g, "");

    _keys = _keys.split("/");

    const _key = _keys.shift().camelCase();

    _keys = _keys.map((_key) => _key.kebabCase());

    if (!_routes[_key]) {
      _routes[_key] = [];
    }

    _routes = _routes[_key];

    _keys.forEach((_key) => {
      let _route = _routes.where("path", _key).first();

      if (!_route) {
        if (!Array.isArray(_data)) {
          _route = {
            routes: [],
            priority: 1,
            ..._data,
            type: "route",
            exact: false, // TODO set true
            path: _key,
          };
        } else {
          _route = {
            type: "route",
            priority: 1,
            permissions: [],
            drawer: true,
            path: _key,
            routes: [],
          };
        }

        _routes.push(_route);
      }

      _routes = _route.routes;
    });

    if (Array.isArray(_data)) {
      _routes.push(..._data.map((_route) => ({ ..._route, exact: true })));
    }
    console.log("routesrouteroutess", routes);
  }
);

const sortRoutesBy = (array, parser) => {
  console.log("arrayarraarrayy",array);
  
  return array
    .clone()
    .map((item) => {
      console.log("iteitemm", item);

      item.routes = sortRoutesBy(item.routes, parser);
      return item;
    })
    .sortBy(parser);
};

routes.home = sortRoutesBy(routes.home, (o) => -o.priority);
console.log("routes.home",routes.home);

export default {
  routes: {
    ...routes,
    home: [
      ...routes.home,
      {
        type: "redirect",
        exact: true,
        path: "/login",
        permissions: [],
        component: null,
        name: null,
        icon: null,
        drawer: false,
        routes: [
          {
            type: null,
            exact: true,
            path: "/",
            permissions: [],
            component: null,
            name: null,
            icon: null,
            drawer: false,
            routes: [],
          },
        ],
      },
      {
        type: "redirect",
        exact: true,
        path: "/",
        permissions: [],
        component: null,
        name: null,
        icon: null,
        drawer: false,
        routes: [
          {
            type: null,
            exact: true,
            path: "dashboard",
            permissions: [],
            component: null,
            name: null,
            icon: null,
            drawer: false,
            routes: [],
          },
        ],
      },
    ],
  },
};
